import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';

/**
 * A wiki category (e.g. "Guides", "Reference") used to organise articles.
 */
export default class WikiCategory extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "slug", Model.attribute('slug'));
    _defineProperty(this, "description", Model.attribute('description'));
    _defineProperty(this, "color", Model.attribute('color'));
    _defineProperty(this, "icon", Model.attribute('icon'));
    _defineProperty(this, "position", Model.attribute('position'));
    _defineProperty(this, "articleCount", Model.attribute('articleCount'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
  }
}
flarum.reg.add('linkrobins-wiki', 'common/models/WikiCategory', WikiCategory);